// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3I2th","emails":"CreateEditClinics_emails__xPezV","emailTagLabel":"CreateEditClinics_emailTagLabel__1CDcW"};